import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import useAxios from "axios-hooks";

import Api from "../../api";

import NavigationSubmenu from "./NavigationSubmenu.jsx";
import styles from "./navigation.module.scss";

const Navigation = ({ className, isOpenedMenu, toggleMenu, allowScroll }) => {
  const [{ data, loading, error }] = useAxios({ url: Api.navigation });
  const clickedElem = useRef();

  const { pathname } = useLocation();

  useEffect(() => {
    const hideOnClickOutside = (e) =>
      (clickedElem.current && clickedElem.current.contains(e.target)) ||
      toggleMenu(false);
    const hideOnResize = (e) => {
      toggleMenu(false);
    };
    document.addEventListener("click", hideOnClickOutside);
    window.addEventListener("resize", hideOnResize);
    return () => {
      document.removeEventListener("click", hideOnClickOutside);
      window.removeEventListener("resize", hideOnResize);
    };
  }, []);

  const nav_list =
    data &&
    data.nav_items?.map((item) => {
      return (
        <div key={item.id} className={styles.LinkWrapper}>
          <Link
            to={item.url_text}
            ref={item.url_text === "/services" ? clickedElem : null}
            className={classNames(
              styles.mainNavItem,
              pathname.includes(item.url_text) && styles.mainNavItemActive,
              item.url_text === "/services" &&
                classNames(
                  isOpenedMenu ? styles.ItemActive : styles.Item,
                  styles.HasSubmenu
                )
            )}
            onClick={(e) => {
              if (item.url_text === "/services") {
                e.stopPropagation();
                e.preventDefault();

                toggleMenu(!isOpenedMenu);
              } else {
                allowScroll && allowScroll();
              }
            }}
          >
            {item.title}
          </Link>

          {isOpenedMenu && item.url_text === "/services" && (
            <NavigationSubmenu
              path={Api.services}
              linkPath={"/services"}
              isOpenedMenu={isOpenedMenu}
              allowScroll={allowScroll}
            />
          )}
        </div>
      );
    });
  return (
    <nav className={classNames(styles.mainNav, className)}>
      {loading && <p>Loading...</p>}

      {error && <p>Error...</p>}

      {nav_list}
    </nav>
  );
};

export default Navigation;
